/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BooksLibraryIcon20Regular = forwardRef('BooksLibraryIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 3a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M7.939 3.647a1 1 0 0 1 .512 1.318L3.415 16.403a1 1 0 1 1-1.83-.806L6.62 4.16a1 1 0 0 1 1.318-.512Z" }),
        React.createElement("path", { d: "M16 4a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V4Z" })));
});
